import { useParams } from "react-router-dom";

export function useRouteParam(paramName: string): string {
  const params = useParams();
  const value = params[paramName];
  if (value === undefined) {
    throw new Error(`Missing parameter on route: ${paramName}`);
  }
  return value;
}
